import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import vuetify from './plugins/vuetify';
import VueViewer from 'v-viewer'
import moment from 'moment'
import axios from 'axios'
import Swal from 'sweetalert2'
import JSEncrypt from 'jsencrypt'
import { SHA256 } from 'crypto-js'
import Cookies from 'js-cookie'
import 'viewerjs/dist/viewer.css'
import 'swiper/swiper-bundle.css'
import 'moment/locale/pt-br'
import SwiperCore, { Navigation, Pagination } from 'swiper/core'
import { loading } from './loading'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import TheMask from 'vue-the-mask'
import CKEditor from '@ckeditor/ckeditor5-vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import GarantePayDataTable from './components/GarantePayDataTable.vue'
import AdmDataTable from './components/AdmDataTable.vue'
import authService from './auth/oidc'
import './assets/css/garantepay-theme.css'

// Chromium pode emitir estes avisos durante o redimensionamento interno de
// componentes como v-autocomplete. Eles não representam uma falha da tela,
// mas o webpack-dev-server os transforma em overlay durante o desenvolvimento.
window.addEventListener('error', (event) => {
  const message = String(event.message || '')
  if (message.includes('ResizeObserver loop completed with undelivered notifications') ||
      message.includes('ResizeObserver loop limit exceeded')) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true)

if (window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor (callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer))
      })
    }
  }
}

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi' // diz pro Vuetify usar MDI como padrão
  }
})

SwiperCore.use([Navigation, Pagination])

const decimalDirective = {
  beforeMount (el, binding) {
    const input = el.querySelector('input') || el

    input.addEventListener('input', () => {
      let value = input.value

      // Remover todos os caracteres não numéricos, exceto ponto e vírgula
      value = value.replace(/[^\d,]/g, '')

      // Se houver mais de uma vírgula, remove a extra
      const parts = value.split(',')
      if (parts.length > 2) {
        parts[1] = parts.slice(1).join('')
        value = parts.join(',')
      }

      // Limitar a 2 casas decimais após a vírgula
      if (parts[1] && parts[1].length > 2) {
        value = `${parts[0]},${parts[1].substring(0, 2)}`
      }

      input.value = value

      // Converter vírgula para ponto para o v-model (back-end usa ponto)
      const numericValue = parseFloat(value.replace(',', '.')) || null
      binding.instance[binding.arg] = numericValue
    })

    input.addEventListener('blur', () => {
      const value = input.value

      // Formatar o valor para duas casas decimais ao perder o foco
      const numericValue = parseFloat(value.replace(',', '.'))
      if (!isNaN(numericValue)) {
        input.value = numericValue.toFixed(2).replace('.', ',') // Mostrar com vírgula
        binding.instance[binding.arg] = numericValue
      } else {
        input.value = ''
        binding.instance[binding.arg] = null
      }
    })
  }
}

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(VueViewer)
app.use(TheMask)
app.use(CKEditor)
app.directive('decimal', decimalDirective)

app.config.globalProperties.$ckconfig = {
  toolbar: ['selectAll', 'heading', '|', 'bold', 'italic', 'strikethrough', 'underline', '|', 'fontSize', 'fontFamily', 'link', '|', 'fontColor', 'fontBackgroundColor', 'bulletedList', 'numberedList', 'blockQuote', 'alignment', 'insertTable', '|'],
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
      { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
      { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
      { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
    ]
  },
  fontFamily: {
    options: [
      'default',
      'Arial, Helvetica, sans-serif',
      'Courier New, Courier, monospace',
      'Georgia, serif',
      'Lucida Sans Unicode, Lucida Grande, sans-serif',
      'Tahoma, Geneva, sans-serif',
      'Times New Roman, Times, serif',
      'Trebuchet MS, Helvetica, sans-serif',
      'Verdana, Geneva, sans-serif'
    ],
    supportAllValues: true
  },
  fontSize: {
    options: [10, 12, 14, 'default', 18, 20, 22, 25, 30, 50, 60],
    supportAllValues: true
  }
}

app.component('EasyDataTable', Vue3EasyDataTable)
app.component('GarantePayDataTable', GarantePayDataTable)
app.component('AdmDataTable', AdmDataTable)

app.config.globalProperties.$loading = loading

// dados GarantePay homolog
app.config.globalProperties.$GarantePayNome = 'GarantePay'
app.config.globalProperties.$GarantePayAstenEmail = 'rogerio@garantepay.com.br'
// app.config.globalProperties.$GarantePayAstenEmail = "contato@avancedigital.com.br";
app.config.globalProperties.$GarantePayEmail = 'suporte@garantepay.com.br'
app.config.globalProperties.$GarantePayLinkAcesso = 'https://garantepay.net.br/'
app.config.globalProperties.$GarantePayLinkAcessoAsten = 'https://plataforma.astenassinatura.com.br/login/GARANTEPAY'
app.config.globalProperties.$DadosCompraManual = 'GarantePayContratacao'

app.config.globalProperties.$scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

app.config.globalProperties.$moment = moment

// homolog
// app.config.globalProperties.$imgURL = 'http://garantepay.kinghost.net/imagensProducao/'
// axios.defaults.baseURL = 'http://controle.garantepay.kinghost.net/api'
app.config.globalProperties.$imgURL = '/api/ProcessAPI'
axios.defaults.baseURL = '/api/ProcessAPI'
axios.defaults.withCredentials = false

// Loading global para todos os processos HTTP. O contador evita que o loader
// seja encerrado antes da hora quando existem várias requisições simultâneas.
axios.interceptors.request.use(
  async config => {
    if (config.showLoading !== false) {
      config.__gpLoading = true
      loading.start()
    }

    const accessToken = await authService.getAccessToken()
    if (accessToken) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  error => {
    if (error.config?.__gpLoading) loading.stop()
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.config?.__gpLoading) loading.stop()
    return response
  },
  error => {
    if (error.config?.__gpLoading) loading.stop()
    return Promise.reject(error)
  }
)

const GpSwal = Swal.mixin({
  width: 430,
  padding: '0 0 18px',
  buttonsStyling: false,
  heightAuto: false,
  showClass: { popup: 'swal2-show gp-swal-show' },
  hideClass: { popup: 'swal2-hide gp-swal-hide' },
  customClass: {
    popup: 'gp-swal-popup',
    icon: 'gp-swal-icon',
    title: 'gp-swal-title',
    htmlContainer: 'gp-swal-message',
    actions: 'gp-swal-actions',
    confirmButton: 'gp-swal-button gp-swal-confirm',
    cancelButton: 'gp-swal-button gp-swal-cancel'
  }
})

const gpToast = (icon, title, mensagem, timer) => GpSwal.fire({
  toast: true,
  position: 'top-end',
  width: 390,
  padding: '12px 14px',
  icon,
  title,
  text: mensagem,
  showConfirmButton: false,
  timer,
  timerProgressBar: true,
  customClass: {
    popup: 'gp-swal-popup gp-swal-toast',
    icon: 'gp-swal-toast-icon',
    title: 'gp-swal-toast-title',
    htmlContainer: 'gp-swal-toast-message',
    timerProgressBar: 'gp-swal-progress'
  }
})

app.config.globalProperties.$mensagemSucesso = function (mensagem) {
  return GpSwal.fire({ icon: 'success', title: 'Tudo certo!', text: mensagem, confirmButtonText: 'Entendi' })
}
app.config.globalProperties.$mensagemErro = function (mensagem, opcoes = {}) {
  return GpSwal.fire({ icon: 'error', title: 'Não foi possível concluir', text: mensagem, confirmButtonText: 'Entendi', ...opcoes })
}
app.config.globalProperties.$mensagemAviso = function (mensagem) {
  return gpToast('warning', 'Atenção', mensagem, 5000)
}

app.config.globalProperties.$mensagemAvisoConfirm = function (mensagem) {
  return GpSwal.fire({
    icon: 'warning',
    title: 'Atenção',
    text: mensagem,
    showConfirmButton: true,
    confirmButtonText: 'Entendi'
  })
}

app.config.globalProperties.$mensagemAvisoSucesso = function (mensagem) {
  return gpToast('success', 'Concluído', mensagem, 2500)
}

app.config.globalProperties.$mensagemConfirma = function (mensagem, opcoes = {}) {
  return GpSwal.fire({
    icon: 'warning',
    title: opcoes.title || 'Confirmar ação',
    text: mensagem,
    showCancelButton: true,
    confirmButtonText: opcoes.confirmButtonText || 'Confirmar',
    cancelButtonText: opcoes.cancelButtonText || 'Cancelar',
    reverseButtons: true
  })
}

app.config.globalProperties.$mensagemSimNao = function (mensagem) {
  return GpSwal.fire({
    icon: 'warning',
    title: 'Confirmação',
    text: mensagem,
    showCancelButton: true,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    reverseButtons: true
  })
}

// Criptografe os dados desejados
app.config.globalProperties.$axios = axios

let loginRedirectPromise = null

function redirectToLogin () {
  if (loginRedirectPromise) return loginRedirectPromise
  const current = router.currentRoute.value
  if (['login', 'AuthCallback', 'AuthCallbackShort'].includes(current?.name)) return Promise.resolve()

  const urlGarantidora = authService.getActiveGuarantorUrl()
  loginRedirectPromise = (async () => {
    await authService.clearAuthState()
    await router.replace({
      name: 'login',
      params: urlGarantidora ? { urlGarantidora } : {},
      query: { authError: '1', redirect: current?.fullPath || '/Home' }
    })
  })().finally(() => { loginRedirectPromise = null })
  return loginRedirectPromise
}

function extrairMensagemErro (error) {
  const data = error?.response?.data
  const status = error?.response?.status
  const mensagens = []
  if (typeof data === 'string' && data.trim()) {
    const texto = data.trim()
    try {
      const json = JSON.parse(texto)
      mensagens.push(json?.message || json?.Message || json?.detail || json?.title || texto)
    } catch { mensagens.push(texto) }
  } else if (data && typeof data === 'object') {
    const principal = data.message || data.Message || data.detail || data.title || data.error || data.Error
    if (principal) mensagens.push(principal)
    if (data.errors && typeof data.errors === 'object') Object.values(data.errors).flat().filter(Boolean).forEach(item => mensagens.push(String(item)))
  }
  const unica = [...new Set(mensagens.map(item => String(item).trim()).filter(Boolean))].join(' ')
  if (unica) return unica.slice(0, 900)
  if (error?.code === 'ERR_NETWORK' || (error?.request && !error?.response)) return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'
  if (status === 403) return 'Você não tem permissão para realizar esta operação.'
  if (status === 404) return 'O recurso solicitado não foi encontrado.'
  if (status === 405) return 'Esta operação não está disponível para a rota informada.'
  if (status >= 500) return `O servidor encontrou um erro ao processar a solicitação (${status}).`
  return error?.message || `Não foi possível concluir a operação${status ? ` (${status})` : ''}.`
}

app.config.globalProperties.$obterMensagemErro = extrairMensagemErro

function erroTecnicoIgnoravel (error) {
  const mensagem = String(error?.message || error || '')
  return mensagem.includes('ResizeObserver loop completed with undelivered notifications') ||
    mensagem.includes('ResizeObserver loop limit exceeded') ||
    /transition \d+ not found/i.test(mensagem)
}

function notificarErroNaoMapeado (error, contexto) {
  if (erroTecnicoIgnoravel(error) || error?.__gpNotified) return

  if (error && typeof error === 'object') error.__gpNotified = true
  console.error(`[GarantePay] ${contexto}`, error)
  app.config.globalProperties.$mensagemErro(extrairMensagemErro(error))
}

// Última barreira para exceções de renderização, eventos e callbacks dos
// componentes. Erros HTTP continuam sendo tratados pelo interceptor do Axios.
app.config.errorHandler = (error, _instance, info) => {
  notificarErroNaoMapeado(error, `Erro não tratado pelo Vue (${info || 'sem contexto'})`)
}

window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason
  if (erroTecnicoIgnoravel(error) || error?.__gpNotified) {
    event.preventDefault()
    return
  }

  event.preventDefault()
  notificarErroNaoMapeado(error, 'Promessa rejeitada sem tratamento')
})

window.addEventListener('error', (event) => {
  if (erroTecnicoIgnoravel(event.error || event.message)) return
  notificarErroNaoMapeado(event.error || new Error(event.message), 'Erro de execução do navegador')
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const status = error?.response?.status
    if (status === 401 && !error?.config?.skipAuthRedirect) {
      error.__gpNotified = true
      // Apenas a rota, sem tokens, corpo ou parâmetros da requisição.
      const path = String(error?.config?.url || '').split(/[?#]/)[0]
      console.warn(`[GarantePay] API rejeitou a sessão (401): ${path}`)
      if (process.env.NODE_ENV === 'development') {
        const challenge = String(error?.response?.headers?.['www-authenticate'] || '')
        const reasons = ['issuer', 'audience', 'signature', 'key', 'expired', 'lifetime', 'invalid_token']
          .filter(reason => challenge.toLowerCase().includes(reason))
        console.warn(`[GarantePay] Diagnóstico 401: ${reasons.join(', ') || 'sem detalhe'}; token enviado: ${Boolean(error?.config?.headers?.Authorization)}`)
      }
      await redirectToLogin().catch(() => {
        window.location.assign('/?authError=1')
      })
      return Promise.reject(error)
    }

    error.__gpMessage = extrairMensagemErro(error)
    if (error.config?.showError !== false) {
      error.__gpNotified = true
      app.config.globalProperties.$mensagemErro(error.__gpMessage)
    }
    return Promise.reject(error)
  }
)

router.isReady().then(() => {
  app.mount('#app')
})
